import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ProfessionalStateService } from '../../services/professional-state.service';
import { NotificationService } from '../../services/notification.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.scss']
})
export class BankAccountsComponent implements OnInit, OnDestroy {
  result: any = { items: [], totalCount: 0, page: 1, pageSize: 20 };
  loading = false;
  professionalId = 0;
  filter: any = { page: 1, pageSize: 20, search: '', isActive: true };

  showModal = false;
  saving = false;
  editingId: number | null = null;
  form: any = {
    bankName: '', accountNumber: '', accountType: '', initialBalance: ''
  };

  private searchInput$ = new Subject<string>();
  private subs = new Subscription();

  constructor(
    private api: ApiService,
    private profState: ProfessionalStateService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this.searchInput$.pipe(debounceTime(400), distinctUntilChanged())
        .subscribe(term => { this.filter.search = term; this.filter.page = 1; this.load(); })
    );

    this.subs.add(
      this.profState.selected$.subscribe(p => {
        if (p) { this.professionalId = p.id; this.load(); }
      })
    );
  }

  ngOnDestroy(): void { this.subs.unsubscribe(); }

  load(): void {
    this.loading = true;
    this.api.getBankAccounts(this.professionalId, this.filter).subscribe({
      next: r => { this.result = r; this.loading = false; },
      error: () => this.loading = false
    });
  }

  onSearch(term: string): void { this.searchInput$.next(term); }
  onPageChange(page: number): void { this.filter.page = page; this.load(); }
  onSizeChange(size: number): void { this.filter.pageSize = size; this.filter.page = 1; this.load(); }

  openModal(bankAccount?: any): void {
    this.editingId = bankAccount?.id ?? null;
    this.form = bankAccount ? { ...bankAccount } : {
      bankName: '', accountNumber: '', accountType: '', initialBalance: ''
    };
    this.showModal = true;
  }

  save(): void {
    if (!this.form.bankName?.trim()) {
      this.notification.warning('Atenção', 'Nome do banco é obrigatório');
      return;
    }

    this.saving = true;
    const op = this.editingId
      ? this.api.updateBankAccount(this.professionalId, this.editingId, this.form)
      : this.api.createBankAccount(this.professionalId, this.form);

    op.subscribe({
      next: () => {
        this.saving = false;
        this.showModal = false;
        this.notification.success('Sucesso!', `Conta bancária ${this.editingId ? 'atualizada' : 'cadastrada'} com sucesso`);
        this.load();
      },
      error: () => {
        this.saving = false;
        this.notification.error('Erro', 'Erro ao salvar conta bancária');
      }
    });
  }

  delete(bankAccount: any): void {
    this.notification.confirm(
      'Confirmar Exclusão',
      `Tem certeza que deseja excluir a conta bancária ${bankAccount.bankName}?`,
      () => {
        this.api.deleteBankAccount(this.professionalId, bankAccount.id).subscribe({
          next: () => {
            this.notification.success('Sucesso!', 'Conta bancária excluída com sucesso');
            this.load();
          },
          error: () => this.notification.error('Erro', 'Erro ao excluir conta bancária')
        });
      }
    );
  }

  fmtDate(d?: string): string {
    if (!d) return '-';
    const date = new Date(d);
    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  }
}
